import { Component, OnInit  } from '@angular/core';
import { Home } from './home.model';
import { Kpi } from "./kpi.model";
import { HomeService} from "./home.service";
import { Router } from '@angular/router';
import { MessagesService} from "../messages.service";

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit  {

    public loadingAccount : boolean;
    public loadingBrand : boolean;
    public loadingKpis : boolean;
    public loadingDashboard : boolean;
    public loadingGrids : boolean;
    
    public businessName : string;
    public home : Home;
    
    constructor(private homeService: HomeService,private router: Router, private messagesService:MessagesService) { }
  
    ngOnInit() {
       this.home = new Home();
       this.loadAccount();
       this.loadKpis();
       this.loadDashboards();
       this.loadGrids();
   }
    
   loadAccount() {
      this.loadingAccount = true;
      this.loadingBrand = true;
      this.homeService.getAccount().subscribe(
            data => { this.loadingAccount = false; this.businessName = data.description; },
            error => {this.loadingAccount = false; this.checkError(error,"Ha ocurrido un error al cargar la cuenta") }
      );
      this.homeService.getBrand().subscribe(
            data => { this.loadingBrand = false;  this.loadBrandImage(data);},
            error => { this.loadingBrand = false; this.checkError(error,"Ha ocurrido un error al cargar el logo") }
      );
   }
    
   loadKpis() {
     this.loadingKpis = true;
     this.homeService.getKpis().subscribe(
        data => { 
            this.loadingKpis = false;  
            this.home.kpis = new Array();
            for (let kpi of data) {
                this.home.kpis.push(new Kpi(kpi));
            };
        },
        error => { this.loadingKpis = false; this.checkError(error,"Ha ocurrido un error al cargar los indicadores") }
    );
   }
    
   loadDashboards() {
    this.loadingDashboard = true;
    this.homeService.getDashboards().subscribe(
        data => { this.loadingDashboard = false;  this.home.dashboards = data.values;},
        error => { this.loadingDashboard = false; this.checkError(error,"Ha ocurrido un error al cargar el dashboard") }
    );
   }
    
   loadGrids() {
        this.home.grids.loadingLastMovements = true;
        this.homeService.getGrid('M').subscribe(
            data => { this.home.grids.loadingLastMovements = false;  this.home.grids.setMovements(data);},
            error => { this.home.grids.loadingLastMovements = false; this.checkError(error,"Ha ocurrido un error al cargar los ultimos movimientos") }
        );
        this.home.grids.loadingLastCounts = true;
        this.homeService.getGrid('C').subscribe(
            data => { this.home.grids.loadingLastCounts = false;  this.home.grids.setCounts(data);},
            error => { this.home.grids.loadingLastCounts = false; this.checkError(error,"Ha ocurrido un error al cargar los ultimos inventarios") }
        );
   }
       
   private checkError(error: any, defaultMessage: string) {
        this.messagesService.checkError(error,defaultMessage);
    }
    
    public hasBrand() : boolean{
        return (this.home.brand.image != null);
    }
        
    private loadBrandImage(data)  {
        let branding : HTMLElement  = document.querySelector('#branding');    
        this.home.brand.image = data.image; 
        this.home.brand.mimeType = data.mimeType; 
        if (this.hasBrand()) {
            branding.style.backgroundImage = 'url(\'data:' + this.home.brand.mimeType + ';base64, ' + this.home.brand.image + '\')'; 
            branding.style.backgroundRepeat = "no-repeat";
            branding.style.backgroundPosition = 'center center';
        }
    }

    
}
